import React from 'react'
import { connect } from 'react-redux'
import { RootState } from 'duck'
import Typography from 'components/Typography'
import { apiSelectors } from 'duck/ApiDuck'
import { useBreakpoint } from 'utils/Hooks'
import ListSocial from 'components/ListSocial'
import stylesGlobal from 'stylesGlobal.module.scss'

const mapStateToProps = (state: RootState) => ({
  openedMineProject: apiSelectors.openedMineProject(state)
})

type ProjectSummaryProps = ReturnType<typeof mapStateToProps>

const ProjectSummary: React.FC<ProjectSummaryProps> = props => {
  const { openedMineProject } = props
  const { isSmallscreenAbove } = useBreakpoint()
  const hasBiography = Boolean(openedMineProject?.artist_biography)

  return (
    <div>
      {hasBiography ? (
        <>
          <Typography variant="body2" color="light" className={stylesGlobal.MarginBottom16}>
            Biography
          </Typography>

          {openedMineProject?.artist_biography?.split('\n').map((text, index) => (
            <Typography key={index} variant="body1" variantXs="body2" paragraph>
              {text}
            </Typography>
          ))}
        </>
      ) : null}

      <ListSocial
        className={hasBiography ? stylesGlobal.MarginTop48 : undefined}
        align={!isSmallscreenAbove ? 'center' : undefined}
        discord={''}
        instagram={openedMineProject?.instagram_url}
        twitter={openedMineProject?.twitter_url}
        url={openedMineProject?.artist_url}
      />
    </div>
  )
}

export default connect(mapStateToProps)(ProjectSummary)
